import { getLocation } from "~/whereami";

// @ts-nocheck
/* eslint-disable */
Mapy.WhereAmI = {
	ContextItem: function(label) {
		SMap.Control.ContextMenu.Item.call(this, label);
	}
}

Mapy.WhereAmI.ContextItem.prototype = Object.create(Object.assign({}, SMap.Control.ContextMenu.Item.prototype));

Mapy.WhereAmI.ContextItem.prototype.click = function(e, menu) {
	if (this._disabled) { return; };

	getLocation(this._coords).then(data => {
		Mapy.getComponent("detail").setState({
			source: data.source,
			id: data.id,
			coords: this._coords,
			gpsCoords: data.gpsCoords,
			manual: true,
			show: false
		}).then(function() { Mapy.getComponent("history").save(); }, () => {});
	}, () => {
		Mapy.getComponent("detail").setState({
			source: "coor",
			id: this._coords.toWGS84().join(","),
			coords: this._coords,
			manual: true,
			show: false
		}).then(function() { Mapy.getComponent("history").save(); }, () => {});
	});

	var tmp = this._coords.toWGS84();
	const logdata = {
		type: "whereami"
	};
	logdata.eventx = tmp[0].toFixed(6);
	logdata.eventy = tmp[1].toFixed(6);
	Mapy.getComponent("logger").log("menu-item", logdata);

	menu.close();
};
